import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DoorOpen from './icon-door-open.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DoorOpen {...validProps} />;
}
SvgComponent.iconName = 'door-open';

/**
 * @deprecated This is a legacy icon
 */
export const DoorOpenIcon = svgIconWrapper(SvgComponent);
